import {apiPath} from "@pg-mono/rp-api-routes";

import {rpApi} from "../../app/api/rp_api";
import {notifyBugsnag} from "../../errors/bugsnag/notify_bugsnag";
import {IApplicationData} from "../types/IApplicationData";

export const createApplicationApi = rpApi.injectEndpoints({
    endpoints: (build) => ({
        createApplication: build.mutation<IApplicationData, Partial<IApplicationData>>({
            query: (body) => ({
                url: apiPath.applications.create.base,
                method: "POST",
                body
            }),
            transformErrorResponse: (data) => {
                const error = `createApplicationApi error: ${data.status}`;
                notifyBugsnag(error, error);

                return data;
            }
        })
    })
});

export const {useCreateApplicationMutation} = createApplicationApi;
import {apiPath} from "@pg-mono/rp-api-routes";

import {rpApi} from "../../app/api/rp_api";
import {notifyBugsnag} from "../../errors/bugsnag/notify_bugsnag";
import {IApplicationData} from "../types/IApplicationData";

export const createApplicationApi = rpApi.injectEndpoints({
    endpoints: (build) => ({
        createApplication: build.mutation<IApplicationData, Partial<IApplicationData>>({
            query: (body) => ({
                url: apiPath.applications.create.base,
                method: "POST",
                body
            }),
            transformErrorResponse: (data) => {
                const error = `createApplicationApi error: ${data.status}`;
                notifyBugsnag(error, error);

                return data;
            }
        })
    })
});

export const {useCreateApplicationMutation} = createApplicationApi;
